<template>
  <base-layout page-default-back-link="/home" hideBackButton="true">
    <br />
    <ion-grid>
      <ion-row>
        <ion-col size="12" style="text-align: center">
          {{ $t("Scegli la lingua per continuare") }}
          <!--<ion-button>Salva</ion-button>-->
        </ion-col>
      </ion-row>
      <ion-row
        ><!-- lista lingue -->
        <ion-col size="12">
          <ion-list>
            <ion-item v-for="item in arcLingue" :key="item.Lin_codi" @click="ImpostaLingua(item)">
              <ion-row>
                <ion-col size="2"><img v-bind:src="require('@/img/flag/' + item.Lin_cnet + '.gif')" style="width: 150px" /> </ion-col>
                <ion-col size="10">{{ item.Lin_desc }}</ion-col>
              </ion-row>

              <!--<div class="rowFx noPaddingAll center item-icon-right">
                  <div class="col-xs-1 col-sm-1 col-md-1 col-lg-2">
                    <img ng-src="img/flag/{{item.Lin_cnet}}.gif" />
                  </div>
                  <div
                    class="col-xs-11 col-sm-11 col-md-11 col-lg-10 text-center"
                  >
                    <span ng-style="Selected(item)" style="font-size: 25px">{{
                      item.Lin_desc
                    }}</span>
                  </div>
                  <i
                    style="font-size: 20px"
                    class="icon ion-checkmark-round"
                    ng-style="Selected(item)"
                    ng-show="Visible(item)"
                  ></i>
                </div>-->
            </ion-item>
          </ion-list>
        </ion-col>
      </ion-row>
    </ion-grid>
  </base-layout>
</template>

<script>
import {
  IonCol,
  IonGrid,
  IonRow,
  IonList,
  IonItem,
  //IonButton,
  //IonIcon
} from "@ionic/vue";

//import router from "../router";

import BaseLayout from "@/components/base/BaseLayout.vue";
import { DbParamType } from "../components/shared/DbParamType";
import { CommandExecutionType } from "../components/shared/CommandExecutionType";
import { ParameterDirection } from "../components/shared/ParameterDirection";
import { CommandParam } from "../components/shared/CommandParam";
import { dataBoxCall } from "../components/shared/GlobalCallSP";
import { store } from "../components/shared/store";

export default {
  name: "ImpostazioniPage",
  components: {
    IonCol,
    IonGrid,
    IonRow,
    IonList,
    IonItem,
    //IonButton,
    //IonIcon,
    BaseLayout,
  },
  data() {
    return {
      //arcLingue: [{ Lin_codi: 96, Lin_desc: "Italiano", Lin_cnet: "it-IT" }],
      arcLingue: [],
      loading: false,
      error: null,
      store
    };
  },
  //created(){
  //    this.getData()
  //},
  methods: {
    //   async getData(){
    //       this.loading = true;
    //       try {
    //           //const req = await fretch
    //       }
    //       catch(e) {
    //           //console.error('Error: ${e}')
    //       }
    //   },
    // prosegui_click() {},
    ImpostaLingua(obj) {
      //let Impostazioni = {};
      //  Impostazioni.Lin_codi = obj.Lin_codi;
      //  Impostazioni.Lin_desc = obj.Lin_desc;
      //  Impostazioni.Lin_cnet = obj.Lin_cnet;
       
      let lng = obj.Lin_cnet.substr(0, 2);
      this.$i18n.locale = lng;
      //this.sStore.set(this.$APP_ID + "lng", lng);

      var saver = JSON.stringify(lng);
      window.localStorage.setItem("Rst_codi", saver);
      //return this.parseValue(saver);
      //this.$USER.Rst_codi = lng;
      this.store.setRst_codi(lng)
      //ChangeLang(obj.Lin_cnet,obj.Lin_codi);
      this.$router.push({ name: "Home" });
    },
    GetDati() {
      const self = this;
      let prm = [];
      // inline

      prm.push(new CommandParam("@Con_toke", "", DbParamType.AnsiString, 10, ParameterDirection.Input, this.$CON_TOKE));
      prm.push(new CommandParam("@Ind_codi", "", DbParamType.AnsiString, 10, ParameterDirection.Input, this.$IND_CODI));
      dataBoxCall
        .Exec(prm, "stpF_Tabella_AttivitaRicreative_Lingue_lst", true, "", CommandExecutionType.ExecuteQuery, false, this.$DATABOX_CFG)
        .then(function (data) {
          if (data && data.RecordSet.Table.length > 0) {
            self.arcLingue = data.RecordSet.Table;
          } else {
            self.arcLingue = [];
          }
        })
        .catch(function (er) {
          console.log("return normale no data" + er);
        });
    },
  },
  mounted() {
    this.GetDati();
  },
};
</script>
